// extracted by mini-css-extract-plugin
export default {"article":"RH34s934dqtWESVFwnMQ"};